import { useTheme } from '@/src/context/ThemeContext';
import { blogPosts } from '@/src/content/blog';
import { WhatsNewScreen } from '@/src/presentation/screens/WhatsNewScreen';

export default function WhatsNewContainer() {
  const { colors } = useTheme();
  return <WhatsNewScreen posts={blogPosts} colors={colors} />;
}
